module.exports = __webpack_public_path__ + "components/MapControl/svg/Teatr.svg?76c6fb38";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Teatr.svg
// module id = 2039
// module chunks = 0